export const getRoundNoSx = (isLastRound, theme, isMultipleRounds) => {
  return {
    display: "flex",
    flexDirection: "column",
    "& .pairingWrapper:nth-of-type(odd):after": isLastRound
      ? null
      : {
          top: "50%",
          borderTop: `1px solid ${theme?.palette?.divider}`,
          borderRight: isMultipleRounds
            ? `1px solid ${theme?.palette?.divider}`
            : null,
          content: '""',
          display: "block",
          position: "absolute",
          right: "calc(-1 * 9px)",
          width: "calc(9px)",
          height: "50%",
        },

    "& .pairingWrapper:nth-of-type(even):after": isLastRound
      ? null
      : isMultipleRounds
        ? {
            top: 0,
            borderBottom: `1px solid ${theme?.palette?.divider}`,
            borderRight: `1px solid ${theme?.palette?.divider}`,
            content: '""',
            display: "block",
            position: "absolute",
            right: "calc(-1 * 9px)",
            width: "calc(9px)",
            height: "50%",
          }
        : null,
  };
};

export const getByeSx = (roundNo, theme) => {
  return {
    flex: 1,
    display: "flex",
    alignItems: "center",
    margin: "8px 0",
    position: "relative",

    "&:before":
      roundNo > 1
        ? {
            top: "50%",
            borderBottom: `1px solid ${theme?.palette?.divider}`,
            content: '""',
            display: "block",
            position: "absolute",
            left: "calc(-1 * 9px)",
            width: "calc(100% + 18px)",
          }
        : null,
  };
};

export const getPairingSx = (roundNo, startRoundNumber = 1, theme) => {
  return {
    flex: 1,
    display: "flex",
    alignItems: "center",
    margin: "8px 0",
    position: "relative",

    backgroundColor: "background.secondary",

    "&:before":
      roundNo > startRoundNumber
        ? {
            top: "50%",
            borderBottom: `1px solid ${theme?.palette?.divider}`,
            content: '""',
            display: "block",
            position: "absolute",
            left: "calc(-1 * 9px)",
            width: "calc(9px)",
          }
        : null,
  };
};

export const roundLabelSx = {
  textAlign: "center",
  backgroundColor: "background.tertiary",
  padding: "10px 0px",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  width: "150px",
  borderRadius: "4px",
  mb: 1,
};

export const byeBoxSx = {
  width: "100%",
  position: "relative",
};

export const pairingBoxSx = {
  border: 1,
  borderRadius: "4px",
  width: "100%",
  position: "relative",
};

export const pairingTypographySx = {
  left: "4px",
  position: "absolute",
  top: "-10px",
  fontSize: ".8em",
  padding: "0 5px",
  backgroundColor: "background.secondary",
  borderRadius: "4px",
};
